import { render, staticRenderFns } from "./AttachmentInput.vue?vue&type=template&id=332d946a"
import script from "./AttachmentInput.vue?vue&type=script&lang=js"
export * from "./AttachmentInput.vue?vue&type=script&lang=js"
import style0 from "./AttachmentInput.vue?vue&type=style&index=0&id=332d946a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports